import "./style.scss";
import InputCustom from "../Input";
import { InputProps } from "semantic-ui-react";

const SearchBar4Table = ({ ...props }: InputProps) => {
  return <InputCustom containerClass={"search-bar-4-table"} {...props} />;
};

export default SearchBar4Table;
